import { initializeApp } from 'firebase/app';
import { getMessaging, getToken } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyB-tjrftC7UnBr1QePZTlovRQz82gOQ2Tk",
  authDomain: "schoolportal-e8980.firebaseapp.com",
  projectId: "schoolportal-e8980",
  storageBucket: "schoolportal-e8980.firebasestorage.app",
  messagingSenderId: "659767531257",
  appId: "1:659767531257:web:35f1cf1f168630ac42b428"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Cloud Messaging
const messaging = getMessaging(app);

// Request permission and get token
const generateFCMToken = async () => {
    try {
        const token = await getToken(messaging, { vapidKey: 'BFU6F4KEdU1eWRxQpoGT5xM8oRNGy6n2OmOruIEksl6LkqqRtN8r-NxZh5fMy6ySZszosXwEXNJw6SnaDKdkSuk' });
        // console.log('FCM Token:', token);
        return token;
    } catch (error) {
        console.error('Error getting FCM token:', error);
    }

};

export { messaging, generateFCMToken };